import React from "react";
import { motion } from "framer-motion";
import { Linkedin, Twitter } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "../Assets/Company_Logo2.png";

export default function Footer() {

  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Contact", path: "/contact" }
  ];

  const services = [
    "Talent Acquisition",
    "Recruitment Outsourcing",
    "HR Consulting",
    "Payroll Management"
  ];

  const socialLinks = [
    { icon: Linkedin, url: "#" },
    { icon: Twitter, url: "#" }
  ];

  return (

    <footer className="bg-gray-50 border-t border-gray-200 py-16 px-6">

      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-10">


        {/* BRAND */}

        <div>

          <Link to="/" className="inline-block mb-4">

           <img
  src={Logo}
  alt="HR Consultancy"
  className="h-16  w-[180px] object-contain"
/>
          </Link>

          <p className="text-gray-600 text-sm leading-relaxed">
            Strategic HR solutions helping organizations build stronger
            teams, improve leadership, and achieve sustainable growth.
          </p>

          <div className="flex gap-3 mt-6">

            {socialLinks.map(({icon:Icon},i)=>(
              <motion.a
                key={i}
                whileHover={{scale:1.1}}
                className="w-9 h-9 border border-gray-300 flex items-center justify-center hover:bg-black hover:text-white transition"
              >
                <Icon size={16}/>
              </motion.a>
            ))}

          </div>

        </div>



        {/* QUICK LINKS */}

        <div>

          <h4 className="font-semibold mb-4">
            Quick Links
          </h4>

          <ul className="space-y-3 text-sm">

            {quickLinks.map((link,i)=>(
              <li key={i}>
                <Link
                  to={link.path}
                  className="text-gray-600 hover:text-black transition"
                >
                  {link.name}
                </Link>
              </li>
            ))}

          </ul>

        </div>



        {/* SERVICES */}

        <div>

          <h4 className="font-semibold mb-4">
            Services
          </h4>

          <ul className="space-y-3 text-sm text-gray-600">

            {services.map((service,i)=>(
              <li key={i}>
                {service}
              </li>
            ))}

          </ul>

        </div>



        {/* CONTACT */}

        <div>

          <h4 className="font-semibold mb-4">
            Contact
          </h4>

          <ul className="space-y-3 text-sm text-gray-600">

            <li>
                No. 18, 7th Main Street


                Vallalar Nagar,
Pattabiram,
Chennai – 600072.
            </li>

            <li>
          malarkrishnanbussiness@gmail.com            
 </li>

            <li>
              +91 97910-78708
            </li>

          </ul>

        </div>

      </div>



      {/* BOTTOM BAR */}

      <div className="max-w-7xl mx-auto border-t border-gray-200 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">

        <p>
          © {currentYear} Malar Krishnan. All rights reserved.
        </p>

        <div className="flex gap-6 mt-4 md:mt-0">

          <Link to="/privacy-policy" className="hover:text-black transition">
            Privacy Policy
          </Link>

          <Link to="/terms-of-service" className="hover:text-black transition">
            Terms of Service
          </Link>

        </div>

      </div>

    </footer>

  );
}